import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrendingBoard from "./components/TrendingBoard";
import FreshSection from "./components/FreshSection";
import CategoryBrowse from "./components/CategoryBrowse";
import Guide from "./components/Guide";
import About from "./components/About";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import { faqs, siteConfig } from "@/mocks/chiGuaData";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      name: siteConfig.brand,
      url: "https://wbjhnw.cn/",
      description: siteConfig.desc,
    },
    {
      "@type": "WebSite",
      name: siteConfig.brand,
      url: "https://wbjhnw.cn/",
      description: "吃瓜网上在线看精选内容，冲浪指南与浏览推荐，热门事件、新鲜事持续更新。",
      inLanguage: "zh-CN",
    },
    {
      "@type": "WebPage",
      name: "吃瓜网上 · 热门事件新鲜事在线看，冲浪指南浏览推荐",
      url: "https://wbjhnw.cn/",
      inLanguage: "zh-CN",
      description: "吃瓜网上在线看精选内容，冲浪指南帮你快速找到感兴趣的话题，浏览推荐不错过任何精彩。",
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Navbar />
      <main>
        <Hero />
        <TrendingBoard />
        <FreshSection />
        <CategoryBrowse />
        <Guide />
        <About />
        <Faq />
      </main>
      <Footer />

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-lg text-background-50 shadow-lg transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line" aria-hidden="true"></i>
        </a>
      )}
    </>
  );
}